import { CustomGuardWeb } from "./routesApp";
import { createRouterByPlatform} from './routesApp';
const router: any = createRouterByPlatform();
//https://router.vuejs.org/guide/advanced/navigation-guards.html
router.beforeEach(async (to:any) => 
{   
  return await CustomGuardWeb(to);  
});
export function getRouter(): any
{      
  return router;
}
export default router
